document.addEventListener('DOMContentLoaded', function() {
    // Update program content
    function updateProgramContent(programLink) {
        const blockContainer = programLink.closest('.program-showcase');
        const contentContainer = blockContainer.querySelector('.program-showcase-content');
        const programTitle = programLink.dataset.programTitle;
        const learnMoreBtn = contentContainer.querySelector('.btn.btn-primary');

        contentContainer.querySelector('.program-title').textContent = programTitle;
        contentContainer.querySelector('.program-description').innerHTML = programLink.dataset.programDescription;
        
        // Only update learn more button if it exists
        if (learnMoreBtn) {
            learnMoreBtn.href = programLink.dataset.programUrl;
            learnMoreBtn.setAttribute('aria-label', `Learn more about ${programTitle}`);
            learnMoreBtn.setAttribute('title', `Learn more about ${programTitle}`);
        }
    }

    // Initialize all program showcase blocks
    document.querySelectorAll('.program-showcase').forEach(block => {
        // Get all major links for this block instance
        const majorLinks = block.querySelectorAll('.major-link');

        // Add click event listeners to all program links within this block instance
        majorLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                // Remove active class from all links in this block
                majorLinks.forEach(link => {
                    link.classList.remove('link-active');
                });
                // Add active class to clicked link
                this.classList.add('link-active');
                // Update program content
                updateProgramContent(this);
            });
        });

        // Update program content via picklist within this block instance
        const picklist = block.querySelector('.program-showcase-picklist select');
        if (picklist) {
            picklist.addEventListener('change', function(e) {
                const selectedProgram = this.options[this.selectedIndex];
                if (selectedProgram.value) {
                    updateProgramContent(selectedProgram);
                }
            });
        }
    });
}); 